import { Component, OnInit, Input } from '@angular/core';
import { GatemanService } from '../../services/gateman.service';
import { footerLinksCtrlInterface, linkInterface } from '../../interfaces/footer-links';

@Component({
  selector: 'app-footer-links',
  templateUrl: './footer-links.component.html',
  styleUrls: ['./footer-links.component.scss']
})
export class FooterLinksComponent implements OnInit {
  @Input() config?: footerLinksCtrlInterface;
  smartlabelFeedback : Array<any>;
  constructor(public gatemanService: GatemanService) { }

  ngOnInit() {
    
    this.smartlabelFeedback = [
      {
          "languageCode": "en",
          "value": "Feedback for Smartlabel"
      },
      {
          "languageCode": "fr",
          "value": "Commentaires sur Smartlabel"
      },
      {
          "languageCode": "en_US",
          "value": "Feedback for Smartlabel"
      },
      {
          "languageCode": "en_CA",
          "value": "Feedback for Smartlabel"
      },
      {
          "languageCode": "fr_CA",
          "value": "Commentaires sur Smartlabel"
      }
    ]
  }
  
}
